import _extends from "@babel/runtime/helpers/esm/extends";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme, styled } from '@mui/material/styles';
import { AvatarLabelGroup } from '../../AvatarLabelGroup';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MenuHeader(_ref) {
  var _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    divider = _ref.divider,
    headerContent = _ref.headerContent,
    headerType = _ref.headerType;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MenuHeaderRoot, {
      divider: divider,
      "data-element": "MenuHeaderRoot",
      "data-source-file": "MenuHeader.tsx",
      children: headerType === 'Avatar Group' && _typeof(headerContent) === 'object' ? /*#__PURE__*/_jsx(AvatarLabelGroup, _extends({}, headerContent)) : /*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[700],
        variant: "text-sm-semibold",
        children: headerContent
      })
    }), /*#__PURE__*/_jsx(Box, {
      className: "menu-item-spacer",
      sx: {
        height: bottomMargin ? 4 : 2
      },
      "data-element": "Box",
      "data-source-file": "MenuHeader.tsx"
    })]
  });
}
var MenuHeaderRoot = styled('div')(function (_ref2) {
  var _ref2$divider = _ref2.divider,
    divider = _ref2$divider === void 0 ? true : _ref2$divider,
    theme = _ref2.theme;
  return {
    borderBottom: divider ? "1px solid ".concat(theme.palette.gray[200]) : 'none',
    minHeight: '44px',
    padding: '12px 16px'
  };
});